export default __webpack_public_path__ + "static/monitor-screenshot-c04a9d4c9b13953a7f90933aae2c3e90.png";